import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { FaultDistribution } from '../../types';

interface DonutChartProps {
  data: FaultDistribution[];
  height?: number;
}

export default function DonutChart({ data, height = 200 }: DonutChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-text-tertiary text-sm">
        No data available
      </div>
    );
  }

  return (
    <div>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={55}
            outerRadius={85}
            paddingAngle={2}
            dataKey="value"
            isAnimationActive={false}
          >
            {data.map((entry) => (
              <Cell key={entry.name} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #DDDDDD' }}
            formatter={(val: unknown, name: unknown) => [`${val}%`, `${name}`]}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-1 gap-1 mt-2">
        {data.map((item, i) => (
          <div key={i} className="flex items-center gap-2 text-xs text-text-secondary">
            <span className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: item.color }} />
            <span className="flex-1">{item.name}</span>
            <span className="font-medium text-text-primary">{item.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
